import { JsonApiModel } from 'pf-frontend-common/src/module/json-api/model';

export class PropertyReportClaimModel extends JsonApiModel {
  /**
   * @inheritDoc
   */
  public static readonly JSONAPI_TYPE: string = 'cmt_claim_transaction';
  /**
   * @inheritDoc
   */
  public jsonApiType: string = PropertyReportClaimModel.JSONAPI_TYPE;
  /**
   * @inheritDoc
   */
  public jsonApiAttributes: Array<keyof PropertyReportClaimModel> = [
    'property_id',
    'agent_email',
    'ref_listings',
    'doc_mou',
    'doc_pos',
  ];
  /**
   * @inheritDoc
   */
  public jsonApiRelationships: Array<keyof PropertyReportClaimModel> = [];
  /**
   * Agent Email
   */
  public agent_email: string = '';
  /**
   * Property id
   */
  public property_id: number = null;
  /**
   * Other listings
   */
  public ref_listings: string = '';
  /**
   * Mou Document Url
   */
  public doc_mou: string = '';
  /**
   * Proof of Ownership Document Url
   */
  public doc_pos: string = '';
}
